<template>
  <div>
    <template v-if="type === FIELD_TYPES.tiles">
      <div class="margin-bottom-m grid-x">
        <div class="grid-y align-center large large-margin-right-s small-margin-bottom-xs large-margin-bottom-z medium-12 large-shrink">
          {{ title }}
        </div>
        <div class="grid-x medium-12 large-auto">
          <SelectionTile
            v-model="localValue"
            :name="name"
            :options="options"
            selection-mode="multiple"
            cell-spacing="shrink"
            :size-tile="true"
            display-mode="stack"
          />
        </div>
      </div>
    </template>

    <template v-if="type === FIELD_TYPES.scale">
      <div class="margin-bottom-m">
        <div class="margin-bottom-xs large large-margin-right-s medium-margin-right-s">
          {{ title }}
        </div>
        <FitScale v-model="localValue" :options="options" spacing="margin-right-xs" :name="name" />
      </div>
    </template>

    <template v-if="type === FIELD_TYPES.size">
      <div class="margin-bottom-m">
        <div class="large margin-bottom-xxs">Size</div>
        <div class="grid-x grid-margin-x">
          <div v-for="(_, index) in options" :key="index" :class="sizeFieldClass" class="cell input-container">
            <InputText :key="`input_${index}`" v-model="localValue[options[index].name]" :name="options[index].name" :label="options[index].label" />
          </div>
        </div>
      </div>
      <div></div>
    </template>
  </div>
</template>

<script setup>
/** @typedef {Object} ExtraQuestionOption
 * @property {string} label
 * @property {string | number} value
 */

import { computed } from 'vue';
import InputText from '@atomic-ui/inputText/InputText';
import SelectionTile from '@atomic-ui/selectionTile/SelectionTile';
import FitScale from './FitScale';

import { FIELD_TYPES } from './constants';

const props = defineProps({
  questionValue: {
    type: [String, Object, Array],
    default: undefined,
  },
  name: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
  options: {
    /** @type import('vue').PropType<Array<ExtraQuestionOption>> */
    type: Array,
    required: true,
    validator(x) {
      let isValid = true;
      if (!x.length) return false;
      x.forEach((el) => {
        if (!(el instanceof Object)) isValid = false;
        if (!('label' in el && 'value' in el) && !('label' in el && 'name' in el) && !('text' in el && 'id' in el)) {
          isValid = false;
        }
      });
      return isValid;
    },
  },
});
const emit = defineEmits(['update:questionValue']);
const sizeFieldClass = computed(() => `large-${12 / props.options.length}`);

const localValue = computed({
  get: () => props.questionValue,
  set: (value) => {
    emit('update:questionValue', value);
  },
});
</script>
